import { useQuery } from "@tanstack/react-query";
import { reportsApi } from "./api";

export function useReportPermissions() {
  return useQuery({
    queryKey: ["reports", "permissions"],
    queryFn: () => reportsApi.getReportPermissions(),
  });
}

